import { proxyBE } from "./common";

export const lessonLiveService = {
  MyScheduleStageOnline(courseId, stageNumber, rCode) {
    let url = `/lesson/live/my-schedule-stage-online/${courseId}/${stageNumber}/${rCode}`;
    return proxyBE.get(url);
  },

  MyScheduleAll(courseId, rCode) {
    let url = `/lesson/live/my-schedule-all/${courseId}/${rCode}`;
    return proxyBE.get(url);
  },

  MyScheduleStageOnlineAll(courseId, rCode) {
    let url = `/lesson/live/my-schedule-stage-online-all/${courseId}/${rCode}`;
    return proxyBE.get(url);
  },

  MyScheduleStageOffline(courseId, stageNumber, rCode) {
    return proxyBE.get(
      `/lesson/live/my-schedule-stage-offline/${courseId}/${stageNumber}/${rCode}`
    );
  },

  myLesson(id, registrationCode) {
    return proxyBE.get("/lesson/live/my-lesson/" + registrationCode + "/" + id);
  },

  generateAttendance(payload) {
    return proxyBE.post("/lesson/live/create-attendance/", { payload });
  },

  myAnalyticResume(rCode) {
    return proxyBE.post("/lesson/live/my-analytics-resume/" + rCode);
  },

  donwloadAttendance(id) {
    return proxyBE.get("/lesson/live/download-attendance/" + id);
  },

  loadFile(fileId) {
    return proxyBE.get("/lessonliveschedule-file-slide/get/" + fileId);
  },

  myOpenClassBooking(registrationCode) {
    return proxyBE.get("/lesson/live/class-booking-my/" + registrationCode);
  },

  isOpenClassBooking(registrationCode) {
    return proxyBE.get("/lesson/live/class-booking-isopen/" + registrationCode);
  },

  myLessonMaterials(registrationCode) {
    return proxyBE.get("/lesson/live/my-materials/" + registrationCode);
  },
};
